import Blue from '~/core'
import { gmapsInit } from '../../vue/src/station-locator/utilities/gmaps'

new Blue({
  name: 'Location Finder',
  selector: '.location-finder',
  setup(container) {
    const form = container.querySelector('form')

    //initAutocomplete(form.dataset.config);

    async function initAutocomplete(config) {
      const response = await fetch(config)
      const gConfig = await response.json()

      let google = await gmapsInit(gConfig.apiKey)

      //enable autocomplete
      let autocomplete = new google.maps.places.Autocomplete(input, {
        fields: ['formatted_address', 'geometry', 'name'],
        strictBounds: false,
      })
      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace()
        if (place != undefined && place.formatted_address != undefined && place.formatted_address != '') {
          input.value = place.formatted_address
        }
      })
    }
  },
})
